<template>
  <div class="containerFull_worldCupAsianZone">
    <FootballCupCommon
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></FootballCupCommon>
  </div>
</template>

<script>
// 足球 杯赛 世界杯亚洲区预选赛 容器
import FootballCupCommon from './footballCup_common.vue'
import containerFull_data from '@mixins/football/cup/containerFull_WCQAZ_data'
export default {
  name: 'containerFull_worldCupAsianZone',
  mixins: [containerFull_data],
  components: {
    FootballCupCommon,
  },
}
</script>
